import Aos from "aos";
import 'aos/dist/aos.css';
import { useEffect } from "react";
import './Common.css';
import './vr.css';


const VrService=()=>{
    useEffect(() => {
        Aos.init({ duration: 1000, offset: 250 });
    });
    return(
        <div id="vr-game" className="container rounded-5">
            <div className="row d-flex justify-content-center align-items-center vr-video-container">
                <div className="col-12">
                    <video className="rounded-5 w-100 h-100" data-aos="zoom-in" autoPlay playsInline muted loop style={{objectFit:"cover"}}>
                        <source type="video/mp4; codecs=&quot;avc1.4D401E, mp4a.40.2&quot;" src="https://cdn.pixabay.com/video/2022/05/27/118363-714645707_large.mp4"></source>
                    </video>
                </div>
                
                <div className="row vr-text-container" data-aos="fade-right">
                    <div className="col-12 text-white">
                        <h1 style={{fontSize: "3rem"}} className="fw-bolder "><span className="text-danger">Virtual</span> Reality Games</h1>
                        <p className="fs-5 lead fw-bold">We specialize in creating immersive VR (Virtual Reality) games 
                            that transport players into captivating virtual worlds. Our games are designed to deliver unmatched 
                            experiences with stunning visuals, realistic interactions, and engaging storylines. Whether it's for entertainment, 
                            education, or training, we craft VR games that blend innovation with creativity, providing players with an unforgettable
                            journey into the virtual realm. Let us bring your ideas to life and redefine gaming with the power of VR! </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default VrService;